import { c as y } from "./createLucideIcon-DSKUQ9gX.mjs.js";
import { S as k, a as V } from "./utils-DrJAg__I.mjs.js";
import { c as C } from "./clsx-OuTLNxxd.mjs.js";
import { j as N } from "./client-BkmPNNjT.mjs.js";
const j = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], A = y("chevron-right", j), m = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, g = C, _ = (n, i) => (e) => {
  var o;
  if (i?.variants == null) return g(n, e?.class, e?.className);
  const { variants: l, defaultVariants: r } = i, f = Object.keys(l).map((t) => {
    const a = e?.[t], d = r?.[t];
    if (a === null) return null;
    const s = m(a) || m(d);
    return l[t][s];
  }), c = e && Object.entries(e).reduce((t, a) => {
    let [d, s] = a;
    return s === void 0 || (t[d] = s), t;
  }, {}), h = i == null || (o = i.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((t, a) => {
    let { class: d, className: s, ...b } = a;
    return Object.entries(b).every((x) => {
      let [v, u] = x;
      return Array.isArray(u) ? u.includes({
        ...r,
        ...c
      }[v]) : {
        ...r,
        ...c
      }[v] === u;
    }) ? [
      ...t,
      d,
      s
    ] : t;
  }, []);
  return g(n, f, h, e?.class, e?.className);
}, p = _("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
  variants: {
    variant: {
      default: "bg-primary text-primary-foreground hover:bg-primary/90",
      destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20",
      outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      link: "text-primary underline-offset-4 hover:underline"
    },
    size: {
      default: "h-9 px-4 py-2 has-[>svg]:px-3",
      sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
      lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
      icon: "size-9"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
});
function B({
  className: n,
  variant: i,
  size: e,
  asChild: o = !1,
  ...l
}) {
  const r = o ? k : "button";
  return /* @__PURE__ */ N.jsx(r, {
    "data-slot": "button",
    className: V(p({
      variant: i,
      size: e,
      className: n
    })),
    ...l
  });
}
export {
  B,
  A as C,
  p as b,
  _ as c
};
